import { SnackbarSizesEnum } from '../_props';

/**
 * Snackbar Classes
 */

const snackbarClasses = 'mx-auto flex py-3 px-4 will-change-transform';
const snackbarVisibilityClasses = 'translate-y-full opacity-0 pointer-events-none';

/**
 * Snackbar Animation Classes
 */

const snackbarAnimationClassesMap = new Map([
  [true, 'animate-snackbar-show'],
  [false, 'animate-snackbar-hide'],
  [null, ''],
]);

/**
 * Snackbar Variants Classes
 */

const snackbarSizeClassesMap = new Map([
  [SnackbarSizesEnum.Full, 'max-w-full'],
  [SnackbarSizesEnum.Default, 'min-w-[328px] max-w-[490px]'],
  [SnackbarSizesEnum.Small, 'min-w-[220px] max-w-[320px]'],
]);

const snackbarFloatClasses = 'fixed w-full bottom-0 z-50';

/**
 * Snackbar Container Classes
 */

const snackbarContainerClasses = 'flex items-center gap-3';

const snackbarContainerSizeClassesMap = new Map([
  [SnackbarSizesEnum.Full, ''],
  [SnackbarSizesEnum.Default, 'min-w-[328px] max-w-[490px]'],
  [SnackbarSizesEnum.Small, 'flex-wrap justify-end'],
]);

/**
 * Snackbar Action Classes
 */

const snackbarActionClasses = 'flex gap-3';

/**
 * Snackbar Common Theme
 */

const snackbarCommonTheme = {
  snackbarClasses,
  snackbarVisibilityClasses,
  snackbarAnimationClassesMap,
  snackbarSizeClassesMap,
  snackbarFloatClasses,
  snackbarContainerClasses,
  snackbarContainerSizeClassesMap,
  snackbarActionClasses,
};

export default snackbarCommonTheme;
